<template>
<div id="login" class="">
  <b-container fluid>
    <b-row>
      <!-- <b-col md="4" class="text-white bg-dark">2 of 2</b-col> -->
      <b-col md="7" class="form-login mx-auto mb-3">
        <b-card class="mb-1 animate__animated animate__fadeIn" footer-class="text-center" no-body>
          <b-card-body class="text-center align-items-center h2">
            <!-- <b-img :src="logoImg" width="100px"></b-img>
            {{ logoName }} -->
            <b-row align-v="center">
              <b-col md="3" class="text-md-right"><b-img :src="logoImg" width="100px"></b-img></b-col>
              <b-col md="9" class="text-md-left">
                <h3><strong>ใบแจ้งการคืนเงิน (Refund Notice)</strong></h3>
                <h4><strong>ส่วนลดค่าธรรมเนียมการศึกษา</strong></h4>
                <h5>ตามประกาศรัฐบาลเพื่อช่วยเหลือสถานการณ์โควิด</h5>
                <!-- <small><b>วันที่ 20-27 กันยายน 2564</b></small> -->
                <!-- <p style="font-size: 50%;"><i>วันที่ 20 กันยายน 2564 (00:00 น.) - วันที่ 27 กันยายน 2564 (23:59 น.)</i></p> -->
              </b-col>
            </b-row>
          </b-card-body>
          <!-- <b-card-footer>
            <b-button variant="outline-secondary" v-b-toggle.collapse-login block>นักศึกษาต้องการอุปกรณ์เรียนออนไลน์ <strong>คลิ๊ก!!!</strong></b-button>
          </b-card-footer> -->
          <!-- <b-collapse id="collapse-login"> -->
          <b-card-body>
            <div class="text-center" v-if="!dataReady">
              <b-spinner style="width: 3rem; height: 3rem;" label="Loading..." variant="info"></b-spinner>
            </div>
            <template v-if="dataReady">
              <!-- <b-alert show dismissible variant="danger"><b class="text-danger">***</b> The registration on this web site is  for Thai citizens or students with National ID starting with 0 only. For International students, you are only eligible for tuition fee discount from Thammasat University (maximum at 20%). You do not need to register on this web site.</b-alert> -->
              <b-card-text>
                <div class="form-label-group">
                  <b-form-input  id="inputUsername" placeholder="Username" autocomplete="off" class="mb-2" v-model="form.UserName" type="text" ></b-form-input>
                  <label for="inputUsername">รหัสนักศึกษา</label>
                </div>
                <div class="form-label-group">
                  <b-form-input  id="inputPassword" placeholder="Password" autocomplete="off" class="mb-2" v-model="form.PassWord" type="password"></b-form-input>
                  <label for="inputPassword">รหัสผ่าน</label>
                </div>
              </b-card-text>
              <b-card-text class="text-center">
                <!-- <p class="mb-2">
                  <span style="color:red">*</span> กรณีที่ยืนยันขอรับสิทธิ์แล้วสามารถทำการแก้ไขตลอดจนปิดระบบและระบบจะใช้ข้อมูลครั้งล่าสุด
                </p>
                <h5 class="mb-2">
                  <span style="color:red">**</span> สำหรับนักศึกษาที่ลงทะเบียนเรียนมากกว่า 1 มหาวิทยาลัย
                  <br>ตามรายชื่อดังต่อไปนี้ <a target="_blank" href="https://icttu.page.link/covid_dup1">icttu.page.link/covid_dup1</a>
                  <br>เข้าไปยืนยันสิทธิ์ที่ <a target="_blank" href="https://covidfund.cupt.net/register">covidfund.cupt.net/register</a>
                  ภายในวันที่ 27 กันยายน 2564 (23:59 น.)
                </h5> -->

                <!-- <p>
                  กรณีที่ยืนยันขอรับสิทธิ์แล้วต้องการทำรายการซ้ำเพื่อเปลี่ยนแปลงสิทธิ์<br>ขอให้นักศึกษาแนบภาพใบยืนยันสิทธิ์เดิม
                  <br>
                  <small>พร้อมแจ้งความจำนงค์มาที่ <a href="https://lin.ee/vBxlVav">ICT TU Helpdesk</a></small>
                </p> -->
              </b-card-text>
              <b-button  variant="success" @click="loginTime" block>Log in</b-button>
              <hr>
              <b-button  variant="primary" to="StaffLogin" block><f-icon icon="id-card"></f-icon> เข้าสู่ระบบสำหรับเจ้าหน้าที่</b-button>
            </template>
          </b-card-body>
          <!-- </b-collapse> -->
          <b-card-footer>
            <b-row v-html="footerHTML"></b-row>
          </b-card-footer>
        </b-card>
        
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import axios from 'axios' // api
export default {
  name: 'Login',
  beforeCreate () {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
    // document.body.className = 'login';
  },
  created () {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
  },
  async mounted () {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด 
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    // console.log("Login mounted")
    // localStorage.removeItem('userData')
    this.$session.destroy()
    this.getIPClient()
  },
  data () {
    return {
      msg: 'Welcome Kathin',
      dataReady: true,
      testerON: false,
      listStdID: [
        // '6001305157',
        // '6001681003',
        // '6301991797',
        // '6401990285',
        // '6401993149',
        // '6401993594',
        // '5902685519',
        // '6102110027',
        // '6303610080',
        // '5607030433',
        // '6307640109',
        // '6019680153',
        // '6019680468',
        // '6219030050',
        // '6009610194',
        // '6409035604',
        // '5910758142',
        // '6110751036',
        // '6210755382',
        // '5906034078',
        // '6206640721',
        // '6306520120',
        // '6212760877',
        // '6018610250',
        // '6004030067',
        // '6304680595',
        // '6324300042',
        // '6222790071',
        // '5723030101'
      ],
      // ipAddress: '',
      form: {
        UserName: '',
        PassWord: ''
      }
    }
  },
  methods: {
    loginTime () {
      // let timeNow = new Date().getTime()
      // if (timeNow > 1632070800000 && timeNow < 1632675599000) {
        this.loginUser()
      // } else {
      //   this.$swal({
      //     titleText: "",
      //     // html: 'เปิดระบบขอเลือกรับสิทธิ์ หรือแก้ไขการเลือกรับสิทธิ์<br>ภายใน <b>วันที่ 20 กันยายน 2564 เวลา 00:00 น.</b><br>ถึง <b>วันที่ 27 กันยายน 2564 เวลา 23:59 น.</b> เท่านั้น',
      //     html: 'ระบบเปิดให้เลือกรับสิทธิ์และแก้ไขใน<b>วันที่ 20 กันยายน 2564 เวลา 00:00 น.</b>ถึง <b>วันที่ 27 กันยายน 2564 เวลา 23:59 น.</b>',
      //     icon: "info"
      //   })
      //   // this.$swal("","เปิดระบบขอเลือกรับสิทธิ์วันที่ 20-27 กันยายน 2564","info")
      // }
      // this.loginUser()
    },
    loginUser () {
      // let _this = this

      this.dataReady = false
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://restapi.tu.ac.th/api/company/auth/Ad/verify",
          // "https://restapi.tu.ac.th/api/v1/auth/Ad/verify",
          this.form,
          // {
          //   "UserName": this.form.UserName,
          //   "IDCard": this.form.PassWord
          // },
          {
            headers: this.headerPrivateAPI
            // headers: this.headerLoginAPI
          }
        )
        .then(async (response) => {
          // console.log('loginUser', response)
          let rs = response.data
          if (rs.status === true) {
            // this.$swal("เข้าระบบสำเร็จ")
            if (rs.type === 'student') {
              let userData = {
                username: rs.userName,
                tu_status: rs.tu_status,
                idCard: rs.idCard,
                statusid: rs.statusid,
                displayname_th: rs.displayname_th,
                displayname_en: rs.displayname_en,
                email: rs.email,
                prefixname: rs.prefixname,
                department: rs.department,
                faculty: rs.faculty
              }
              userData.timeout = new Date().getTime() + 900000

              this.checkData(userData)
            } else {
              this.$swal("ผิดพลาด","อนุญาตให้เฉพาะนักศึกษาเท่านั้น","error")
            }
          } else {
            // console.log('loginUser Fail')
            this.$swal("ผิดพลาด","ไม่สามารถเข้าระบบได้","error")
            this.dataReady = true
          }
          this.dataReady = true
        })
        .catch((error) => {
          console.log('err: ',error.response)
          if (error.response) {
            if (error.response.status === 401){
              this.$swal("ผิดพลาด", 'เนื่องจากมีผู้ใช้งานเป็นจำนวนมาก กรุณารอประมาณ 10 นาทีแล้วจึงทำรายการใหม่อีกครั้ง', "error")
            }
            if (error.response.data.message === 'Password Invalid!' || error.response.data.message === 'User or Password Invalid!') {
              this.$swal("ผิดพลาด", 'รหัสนักศึกษาหรือรหัสผ่านของท่านไม่ถูกต้อง', "error")
            }
          } else {
            this.$swal("ผิดพลาด","ไม่สามารถเข้าระบบได้","error")
          }
          
          this.dataReady = true
        })
    },
    checkData (userDT) {
      // console.log('Base64', Base64.encode(jsonData)) 
      // let base64Data = Base64.encode(jsonData)
      // localStorage.setItem('userData', JSON.stringify(userData))
      this.dataReady = false

      this.$session.start()
      let jsonData = JSON.stringify(userDT)
      this.$session.set('jwt', jsonData)

      let dt = { username: userDT.username }

      let hk = this.getHashKey(dt)

      let header = {
        'application-key': this.headerAPI['application-key'] + hk
      }
      
      axios
        .get(
          // eslint-disable-next-line quotes
          "https://restapi.tu.ac.th/tu_covid_api/Refund/check_data?username=" + dt.username,
          {
            headers: header
          }
        )
        .then(async (response) => {
          // console.log('registerClaim', response)
          let rs = response.data
          if (rs.status === true) {
            // this.$session.set('cft', rs.statusConfirm)
            // // this.$router.push({ path: 'Certificate', query: { userStatus: 'h' } })
            this.$router.push('/Certificate')
          } else {
            this.$swal("ผิดพลาด","ไม่พบข้อมูลการขอรับสิทธิ์ลดหย่อนของนักศึกษา","error")

            // if (this.listStdID.includes(dt.username)) {
            //   this.$router.push('/Request')
            // } else {
            //   this.$swal({
            //     titleText: "",
            //     html: 'ระบบเปิดให้เลือกรับสิทธิ์และแก้ไขใน<b>วันที่ 20 กันยายน 2564 เวลา 00:00 น.</b>ถึง <b>วันที่ 27 กันยายน 2564 เวลา 23:59 น.</b>',
            //     icon: "info"
            //   })
            // }
          }
          this.dataReady = true
        })
        .catch((error) => {
          // console.log(error.response)
          // this.$swal("ผิดพลาด","ไม่สามารถลงทะเบียนขอรับสิทธิ์ลดหย่อนได้","error")
          this.$swal("ผิดพลาด","ไม่พบข้อมูลการขอรับสิทธิ์ลดหย่อนของนักศึกษา","error")
          this.dataReady = true
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-login{
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue